<app-modal
  #modal
  [modalConfig]="{
    titleText: 'LMS Course Registrations',
    options: { size: 'xl' },
    headerClass: ['modal-header', 'bg-primary', 'text-white', 'border-0'],
    bodyClass: ['p-0'],
    customFooter: true
  }"
  (isClosing)="resetModal()"
  (isDismissing)="resetModal()">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="modal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <div class="w-100" style="background-color: #fff; min-height: 500px">
    <ng-container *ngIf="!isLoading; else loading">
      <div class="table-wrapper w-100 mt-3 px-xl-5">
        <table
          *ngIf="
            course && course.registrations && course.registrations.length > 0;
            else noResults
          "
          class="table gl-striped-table my-4">
          <!--TABLE HEADER-->
          <thead>
            <tr class="align-middle">
              <th scope="col">Date</th>
              <th class="no-wrap" scope="col">User</th>
              <th class="no-wrap" scope="col">Completion</th>
              <th class="no-wrap" scope="col">Seconds Tracked</th>
            </tr>
          </thead>
          <!--TABLE BODY-->
          <tbody>
            <tr
              *ngFor="let registration of course.registrations"
              class="align-middle">
              <td>{{ registration.created_at | formatDate }}</td>
              <td>
                <a href="/portfolio/{{ registration.user_id }}"
                  >{{ registration.user?.profile?.first_name }}
                  {{ registration.user?.profile?.last_name }}</a
                >
              </td>
              <td>{{ registration.percent_complete }}</td>
              <td>{{ registration.seconds_tracked }}</td>
            </tr>
          </tbody>
        </table>
        <ng-template #noResults>
          <div
            class="w-100 p-5 text-center d-flex justify-content-center align-items-center"
            style="min-height: 300px">
            <div class="xtext-center xtext-body-secondary">
              There are no registrations.
            </div>
          </div>
        </ng-template>
      </div>
    </ng-container>

    <ng-template #loading>
      <div class="w-100" style="background-color: #fff; height: 400px">
        <app-loader></app-loader>
      </div>
    </ng-template>
  </div>
  <div footerContent>
    <button
      type="button"
      class="btn btn-md btn-primary"
      (click)="modal.close(); resetModal()">
      Done
    </button>
  </div>
</app-modal>
